import React from 'react'
import { useTranslation } from "react-i18next";
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  TextField: {
    width: '100%',
    marginBottom: '2px'
  }
}));

const SomuraTextFieldLargeMUI = (props) => {
  const classes = useStyles()
  const { t } = useTranslation();
  return (
    <TextField
      className={classes.TextField + " " + props.className}
      disabled={props.disabled}
      type={props.type}
      name={props.name}
      value={props.value}
      label={t(props.label)}
      variant="outlined"
      size="small"
      autoFocus={props.autoFocus}
      multiline
      rows={props.rows}
      onChange={props.onChange}
      onBlur={props.onBlur}
      InputLabelProps={{
        shrink: props.type === "date" || props.value !== "" || props.autoFocus,
      }}
      InputProps={{
        endAdornment: props.adornmentText ? (
          <InputAdornment position="end">{props.adornmentText}</InputAdornment>
        ) : (
          ""
        ),
        inputProps: { min: props.min, max: props.max, step: props.step },
        style: { display: "block" },
      }}
    />
  );
}

export default SomuraTextFieldLargeMUI
